import { useEffect } from "react";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import { useDateRange } from "../../Hooks/useDatePicker";
import { toast } from "react-toastify";
import DateRangeButtons from "../DateRangeButtons";
import useWindowWidth from "../../Hooks/useWindow";
const dateOptions = [
  { label: "Current Month", value: "current_month" },
  { label: "Last Month", value: "last_month" },
  { label: "Last 3 Months", value: "last_3_months" },
  { label: "Last 6 Months", value: "last_6_months" },
  { label: "Current Fin. Year", value: "current_financial_year" },
  { label: "Last Year", value: "last_year" },
  { label: "Last Fin. Year", value: "last_financial_year" },
  { label: "Custom Range", value: "custom" },
];

const DateFilterBar = ({ onGo, isShow = false }) => {
  const { fromDate, toDate, rangeLabel, setRange, setCustomRange } =
    useDateRange();
  useEffect(() => {
    if (isShow) return;
    onGo(fromDate, toDate);
  }, []);

  const handleClickOnGo = () => {
    if (rangeLabel === "custom" && (!fromDate || !toDate)) {
      toast.warn("Please Select Date Range !", {
        toastId: "Date",
      });
      return;
    }
    onGo(fromDate, toDate);
  };
  const width = useWindowWidth();
  return (
    <>
      <div className="dateContainer">
        {isShow && (
          <>
            <h6>Quick Ranges</h6>
            <DateRangeButtons
              onSelect={(label, { from, to }) => {
                setRange(label);
                setCustomRange(from, to);
              }}
            />
          </>
        )}
        {isShow && <h6> Custom Date Range</h6>}
        <div
          className={`datePicker`}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            paddingBottom: "5px",
            flexWrap: "wrap",
          }}
        >
          {/* Custom Range DatePickers (always visible) */}
          <DatePicker
            format="dd-MM-yyyy"
            value={fromDate}
            onChange={(e) => setCustomRange(e.value, toDate)}
            max={new Date()}
            label="From Date"
            style={width > 460 ? { minWidth: "200px" } : { width: "45%" }}
          />
          <DatePicker
            format="dd-MM-yyyy"
            value={toDate}
            onChange={(e) => setCustomRange(fromDate, e.value)}
            max={new Date()}
            label="To Date"
            style={width > 460 ? { minWidth: "200px" } : { width: "45%" }}
          />
          {/* Conditional Rendering */}

          {!isShow && (
            <DropDownList
              data={dateOptions}
              textField="label"
              dataItemKey="value"
              value={dateOptions.find((opt) => opt.value === rangeLabel)}
              onChange={(e) => setRange(e.value.value)}
              style={width > 460 ? { width: "150px" } : { width: "80%" }}
              label="Quick Ranges"
            />
          )}
          <Button themeColor="success" onClick={handleClickOnGo}>
            GO
          </Button>
        </div>
      </div>
    </>
  );
};

export default DateFilterBar;
